export default "__VITE_ASSET__DLM_O_Pf__"